module.exports = __webpack_public_path__ + "dimer/static/img/3.3df69a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/globalPartner/3.jpg
// module id = zlMN
// module chunks = 0